import styled from "styled-components";
import { DARK_GRAY } from "../../../config";

export const Container = styled.div<{ box: boolean }>`
  background-color: ${({ box }) => (box ? `${DARK_GRAY}` : ``)};
  padding: ${({ box }) => (box ? "15px" : `0px`)};
  border-radius: 4px;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
